import { call, put, select, takeLeading } from 'redux-saga/effects';
import i18n from 'common/language/i18n';
import { showSnackbar } from 'common/redux/global/reducer/snackbarSlice';
import { partnerIdSelector, userEmailSelector } from 'common/redux/global/selectors';
import { postPartnerPriceListImport } from 'api/partner-price-list';
import { downloadPartnerProducts } from './api';
import {
  downloadProductsRequest,
  downloadProductsSettled,
  uploadProductsListRequest,
  uploadProductsListSettled
} from '../actions';

function* downloadProductsWorker() {
  try {
    const response = yield call(downloadPartnerProducts);
    if (response.status === 200) {
      const emailRaw = yield select(userEmailSelector);
      const email = emailRaw != null ? String(emailRaw).trim() : '';
      yield put(
        showSnackbar({
          message: email
            ? i18n.t('products:landing.export_download_success', { email })
            : i18n.t('products:landing.export_download_success_no_email')
        })
      );
    } else {
      yield put(
        showSnackbar({
          message: i18n.t('products:landing.export_download_error'),
          error: true
        })
      );
    }
  } catch (error) {
    console.log(error);
    yield put(
      showSnackbar({
        message: i18n.t('products:landing.export_download_error'),
        error: true
      })
    );
  } finally {
    yield put(downloadProductsSettled());
  }
}

function* uploadProductsListWorker(action) {
  try {
    const raw = action.payload;
    let file;
    let partnerId =
      raw && typeof raw === 'object' && !(raw instanceof File) && raw.partnerId != null
        ? String(raw.partnerId).trim()
        : '';
    if (raw && typeof raw === 'object' && !(raw instanceof File) && raw.file instanceof File) {
      file = raw.file;
    } else if (raw instanceof File) {
      file = raw;
    }
    if (!partnerId) {
      partnerId = yield select(partnerIdSelector);
      if (partnerId != null && partnerId !== '') {
        partnerId = String(partnerId);
      } else {
        partnerId = '';
      }
    }
    if (partnerId === '') {
      yield put(
        showSnackbar({
          message: i18n.t('products:landing.upload_list_no_partner'),
          error: true
        })
      );
      return;
    }
    if (!(file instanceof File)) {
      yield put(
        showSnackbar({
          message: i18n.t('products:landing.upload_list_invalid_file'),
          error: true
        })
      );
      return;
    }
    const { status } = yield call(postPartnerPriceListImport, partnerId, file);
    if (status >= 200 && status < 300) {
      yield put(
        showSnackbar({
          message: i18n.t('products:landing.upload_list_success')
        })
      );
    } else {
      yield put(
        showSnackbar({
          message: i18n.t('products:landing.upload_list_error'),
          error: true
        })
      );
    }
  } catch (error) {
    yield put(
      showSnackbar({
        message: i18n.t('products:landing.upload_list_error'),
        error: true
      })
    );
  } finally {
    yield put(uploadProductsListSettled());
  }
}

function* productsSaga() {
  yield takeLeading(downloadProductsRequest, downloadProductsWorker);
  yield takeLeading(uploadProductsListRequest, uploadProductsListWorker);
}

export default productsSaga;
